import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import { BANK_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_BANK,
  CLEAR_BANKS,
  FLAG_BANK_ACTIVITY,
  FLAG_GETTING_BANKS,
  GET_BANK,
  GET_BANKS,
} from '../types';
import { BANK_PATH } from '../../config/paths';

const flagGettingBanks = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BANKS,
    payload: flag,
  });

const getBanks = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBanks(true));
    const query = tableFilters;
    const url = `${BANK_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const costCenters = await response.json();
    dispatch({
      type: GET_BANKS,
      payload: costCenters,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingBanks(false));
  }
};

const clearBanks = () => (dispatch) =>
  dispatch({
    type: CLEAR_BANKS,
  });

const flagBankActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BANK_ACTIVITY,
    payload: flag,
  });

const getBank =
  async ({ bankId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));
      const url = `${BANK_ENDPOINT}/${bankId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const bank = await response.json();
      dispatch({
        type: GET_BANK,
        payload: bank,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

const clearBank = () => (dispatch) =>
  dispatch({
    type: CLEAR_BANK,
  });

const postBank =
  async ({ name, swiftCode, countryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));
      const payload = { name, swiftCode, countryId };
      const url = BANK_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const bank = await response.json();
      dispatch(push(`${BANK_PATH}/${bank.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

const putBank =
  async (bankId, { name, swiftCode, countryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));

      const payload = {
        id: bankId,
        name,
        swiftCode,
        countryId,
      };

      const url = `${BANK_ENDPOINT}/${bankId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(response, null, dispatch);
      const bank = await response.json();
      dispatch(push(`${BANK_PATH}/${bank.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

const deleteBank =
  async ({ bankId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBankActivity(true));
      const url = `${BANK_ENDPOINT}/${bankId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response.json();
      dispatch(push(BANK_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBankActivity(false));
    }
  };

export {
  getBanks,
  clearBanks,
  getBank,
  clearBank,
  postBank,
  putBank,
  deleteBank,
};
